import React from 'react'
import styled from '@emotion/styled'
import { Activity } from '../../../pure-js/types/GrooverTypes'
import Box from './Box'
import GrooverText from './GrooverText'

interface PreSelectedActivityProps {
  activity: Activity
}

const PreSelectedActivity: React.FC<PreSelectedActivityProps> = ({ activity }) => {
  return (
    <Container direction="row" gap="8px" fullWidth>
      <GrooverText textKey="registrationHeadersAndStatusPreSelectedActivityLabel" />
      <ActivityName>{activity.name}</ActivityName>
    </Container>
  )
}

const Container = styled(Box)`
  align-items: center;
  background-color: rgb(248, 247, 247);
  padding: 8px 16px;
`

const ActivityName = styled.span`
  font-weight: 500;
`

export default PreSelectedActivity
